<template>
  <div class="wf-layer-row">
    <div class="start">
      <WfLayerName
        :layer="layer"
        :is-non-auto-layout-frame="isLayerUnsupported"
        :is-image="isImage"
      />
      <WfLayerFacets v-if="!isLayerUnsupported" :layer="layer" />
    </div>
    <div class="end">
      <template v-if="!isLayerUnsupported">
        <WfLayerActions :layer="layer" :is-image="isImage" />
        <WfLayerCopyAI v-if="isCopyToAIEnabled" :layer="layer.layerData" />
        <WfLayerCopy v-else :layer="layer.layerData" />
        <WfHandleAICopyEventRenderless v-if="isCopyToAIEnabled" />
        <WfHandleCopyEventRenderless v-else />
      </template>
      <WfLayerWarning v-else :message="warningMessage" />
    </div>
  </div>
</template>
<script>
import { isLayerUnsupported, isGridLayout } from '@/helpers/layers/layersHandler';
import { FF_COPY_TO_AI_ASSISTANT, hasFeatureFlag } from '@/helpers/featureflags';
import WfLayerCopy from './WfLayerCopy.vue';
import WfLayerName from './layerName/WfLayerName.vue';
import WfLayerFacets from './layerFacets/WfLayerFacets.vue';
import WfLayerActions from './layerActions/WfLayerActions.vue';
import WfLayerWarning from './WfLayerWarning.vue';
import WfLayerCopyAI from './WfLayerCopyAI.vue';
import WfHandleAICopyEventRenderless from '@/components/WfHandleAICopyEventRenderless.vue';
import WfHandleCopyEventRenderless from '@/components/WfHandleCopyEventRenderless.vue';

export default {
  components: {
    WfLayerCopy,
    WfLayerCopyAI,
    WfLayerName,
    WfLayerFacets,
    WfLayerActions,
    WfLayerWarning,
    WfHandleAICopyEventRenderless,
    WfHandleCopyEventRenderless,
  },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasNoChildren() {
      return this.layer.layerData.childrenCount === 0;
    },
    hasOneFill() {
      return this.layer.layerData.fillsCount === 1;
    },
    isImage() {
      return this.layer.layerData.type === 'IMAGE' || (this.hasOneFill && this.hasNoChildren);
    },
    isLayerUnsupported() {
      return isLayerUnsupported(this.layer) && !hasFeatureFlag(FF_COPY_TO_AI_ASSISTANT);
    },
    warningMessage() {
      return isGridLayout(this.layer) ? 'Grid layout is not supported' : undefined;
    },
    isCopyToAIEnabled() {
      return hasFeatureFlag(FF_COPY_TO_AI_ASSISTANT);
    },
  },
};
</script>
